<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            パーツセットのシナリオ化
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-primary" has-icon>
              「{{selectScenarioBotName}}」へ「{{selectRoboPartsSet ? selectRoboPartsSet.robo_parts_set_name : ''}}」のシナリオ化を実行します。</br>
              ※他のパーツと重なって取り込まれるのでご注意ください。</br>
              ※入力設定と出力設定はクリアされます。
            </b-message>
          </p>
          <hr>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">閉じる</a>
          <a class="card-footer-item" @click="clickImportRoboPartsSet()">保存</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ModalExportListScenario',
  data () {
    return {
      isCardModalActive: false,
      scenarioName: ''
    }
  },
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'isModalImportListScenario', 'selectScenario', 'selectScenarioBotName', 'selectRoboPartsSet', 'selectScenarioName']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalImportListScenario () {
      this.isCardModalActive = this.isModalImportListScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    clickImportRoboPartsSet () {
      this.$store.dispatch('chatbot/setImportScenarioFlag', true)
      this.$store.dispatch('chatbot/importRoboPartsSet', {scenarioName: this.selectScenarioName, roboPartsSet: this.selectRoboPartsSet})
      this.$store.dispatch('chatbot/closeModalScenario')
      this.isCardModalActive = false
      event.preventDefault()
      setTimeout(() => {
        console.debug('import after reload')
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.selectScenarioName })
        this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + this.selectScenarioName)
      }, 700)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalImportListScenario.vue